import { TableColumn } from '../types';

// Base column template for reuse
export const createBaseColumn = (id: string, name: string, overrides: Partial<TableColumn> = {}): TableColumn => {
  const baseColumn = {
    id,
    name,
    cell_type: 'normal' as const,
    data_type: 'text' as const,
    prompt: '', // Add missing prompt field
    label_options: [],
    response_format: 'short' as const,
    platform_resources: [],
    // Communication-specific defaults
    requires_thread: true,
    communication_sources: ['email_history', 'outlook_conversations'] as ('email_history' | 'outlook_conversations' | 'gmail_conversations' | 'instagram_messages')[],
    // Dependencies
    depends_on: undefined,
    ...overrides
  };


  return baseColumn;
};
